import React, { createContext, ReactNode, useContext, useState } from "react";
import { IAddress } from "interfaces/Address";
import { IFormError } from "interfaces/ExpressError";
import { ICreateOccurrence, IOccurrence } from "interfaces/Occurrence";
import { IPoliceman } from "interfaces/Policeman";
import { ISuperficialClient } from "interfaces/SubClient";

import { ISuperficialIVehicleProps } from "interfaces/Vehicle";
import { getOccurrencesIdService } from "services/OccurrenceService";
import { FormError } from "./IUserContext";

type ProviderValues = {
  children: ReactNode;
};

type ContextValues = {
  locale: IAddress;
  setLocale: React.Dispatch<React.SetStateAction<IAddress>>;
  setErrors: React.Dispatch<React.SetStateAction<IFormError>>;
  removeError: (field: string) => void;
  searching: boolean;
  errors: IFormError;
};

export const LocaleRegisterContext = createContext({} as ContextValues);

export function LocaleRegisterProvider({ children }: ProviderValues) {
  const [locale, setLocale] = useState<IAddress>({} as IAddress);

  const [errors, setErrors] = useState<IFormError>({});
  const [searching, setSearching] = useState<boolean>(false);

  function removeError(field: string) {
    const _errors = { ...errors };
    delete _errors[field];

    setErrors(() => {
      return _errors;
    });
  }

  return (
    <LocaleRegisterContext.Provider
      value={{
        locale,
        setLocale,
        errors,
        setErrors,
        removeError,
        searching,
      }}
    >
      {children}
    </LocaleRegisterContext.Provider>
  );
}

export const useLocaleRegister = () => {
  return useContext(LocaleRegisterContext);
};
